<template>
    <div class="worldview position-relative">
        <div class="title"></div>
        <div class="w-cont d-flex align-items-center justify-content-center">
            <div class="lf">
                <div class="w-title"></div>
                <div class="text"></div>

            </div>
            <div class="player-bg position-relative">
                <div class="player position-absolute cursor" @click="handleShowVideo()"></div>
            </div>
        </div>
        <!-- 视频弹出框。 -->
        <!-- <div v-if="videoFlag" class="model position-fixed videoFlag">
            <div class="video-bg position-relative ">
                <div class="close position-absolute cursor" @click="closeVideo()"></div>
                <div class="embed-responsive-16by9">
                    <video loop muted autoplay class="videobox position-absolute" :style="scaleStyle">
                        <source src="https://resource-mp4.ujoygames.com/toa/ujoyJpCV.mp4" type="video/mp4" />
                    </video>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            videoFlag: false
        }
    },
    methods: {
        handleShowVideo() {
            // this.videoFlag = true
            this.$emit('showVideo')
        },
        closeVideo() {
            this.videoFlag = false
        }
    }
}
</script>
<style lang='scss' >
.worldview {
    height: 1083px;


    .title {
        background: url("../../assets/img/worldview/title.png") no-repeat center top;
        background-size: 100% 100%;
        width: 675px;
        height: 183px;
        margin: 0 auto;
    }

    .w-cont {
        margin-top: 60px;

        .lf {
            .w-title {
                background: url("../../assets/img/worldview/cnt-title.png") no-repeat center top;
                background-size: 100% 100%;
                width: 335px;
                height: 29px;
            }

            .text {
                background: url("../../assets/img/worldview/cnt-text.png") no-repeat center top;
                background-size: 100% 100%;
                width: 652px;
                height: 313px;
                margin-top: 60px;

            }
        }

        .player-bg {
            background: url("../../assets/img/worldview/player-bg.png") no-repeat center top;
            background-size: 100% 100%;
            width: 930px;
            height: 604px;

            .player {
                background: url("../../assets/img/worldview/player.png") no-repeat center top;
                background-size: 100% 100%;
                width: 115px;
                height: 116px;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }

    .videoFlag {
    }
  
}
</style>


// WEBPACK FOOTER //
// src/components/mainComponents/worldview.vue